import React from "react";
import { Spinner } from "react-bootstrap";

const TransactionsTableSection = ({
  loadingTxs,
  unsettledTxs,
  selectedLogs,
  commType,
  commVal,
  onToggle,
  onSelectAll,
  selectedItems,
  totalGrossAmount,
  totalCommissionAmount,
}) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <h2 className="bma-card-title mb-3">3. Select Transactions to Settle</h2>
        {loadingTxs ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : (
          <div className="table-responsive">
            <table className="bma-table">
              <thead>
                <tr>
                  <th width="40">
                    <input
                      type="checkbox"
                      checked={selectedLogs.length === unsettledTxs.length && unsettledTxs.length > 0}
                      onChange={onSelectAll}
                      disabled={unsettledTxs.length === 0}
                    />
                  </th>
                  <th>ORDER ID</th>
                  <th>PROJECT</th>
                  <th>ROLE</th>
                  <th>AUDITION / SERVICE</th>
                  <th>TRANSACTION TYPE</th>
                  <th>TRANSACTION DATE</th>
                  <th>AMOUNT (₹)</th>
                  <th style={{ color: "#f59e0b" }}>CD COMMISSION (₹)</th>
                </tr>
              </thead>
              <tbody>
                {unsettledTxs.length > 0 ? (
                  unsettledTxs.map((tx) => {
                    const txId = tx.id || tx.payment_log_id;
                    const gross = Number(tx.gross_amount ?? tx.amount ?? 0);
                    const commission = Number(tx.platform_fee ?? tx.commission ?? 0);

                    return (
                      <tr key={txId}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedLogs.includes(txId)}
                            onChange={() => onToggle(txId)}
                          />
                        </td>
                        <td style={{ fontFamily: "monospace", fontWeight: "700" }}>
                          {tx.orderId || tx.payment_order_id || `ORD-${txId}`}
                        </td>
                        <td>{tx.project || tx.project_name || "Project Not Found"}</td>
                        <td>{tx.role || tx.role_name || "Role Not Found"}</td>
                        <td>{tx.service || "Audition Payment"}</td>
                        <td>{tx.type || "Audition Fee"}</td>
                        <td style={{ color: "#94a3b8" }}>
                          {tx.date ? new Date(tx.date).toLocaleDateString("en-IN") : "—"}
                        </td>
                        <td style={{ fontWeight: "700", color: "#ffffff" }}>
                          ₹ {gross.toFixed(2)}
                        </td>
                        <td style={{ fontWeight: "700", color: "#f59e0b" }}>
                          ₹ {commission.toFixed(2)}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-4 text-muted">
                      No unsettled transactions found for this Casting Director.
                    </td>
                  </tr>
                )}
              </tbody>
              {unsettledTxs.length > 0 && (
                <tfoot style={{ borderTop: "2px solid #24283b", backgroundColor: "rgba(255, 255, 255, 0.02)" }}>
                  <tr>
                    <td colSpan={6} style={{ fontSize: "0.85rem", color: "#94a3b8", fontWeight: "600" }}>
                      Showing {selectedItems.length} of {unsettledTxs.length} transactions (Total Selected: {selectedItems.length})
                    </td>
                    <td style={{ fontWeight: "800", fontSize: "0.95rem", color: "#4ade80", whiteSpace: "nowrap" }}>
                      ₹ {totalGrossAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ fontWeight: "800", fontSize: "0.95rem", color: "#f59e0b", whiteSpace: "nowrap" }}>
                      ₹ {totalCommissionAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionsTableSection;